<!-->┌────┬─────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│ PA │                                   Wallet                                        │<- ->
<- ->└────┴─────────────────────────────────────────────────────────────────────────────────┘<--->

<style scoped lang="less" src=":/PA/styles/ff_dashboard/wallet.less"></style>

<script>
    import Wallet from "@/pages/ff_dashboard/wallet"
    export default {
        ...Wallet
    }
</script>
